import { useQuery } from 'react-query';

import { getHeatMapSummary as queryFn } from 'api/endPoints/getHeatMapSummary';
import { QueryKeys } from 'api/queryKeys';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

export const useQueryTimelineAndDensity = (params: QueryParams) => {
    return useQuery<QueryResponse, QueryError, QueryResponse, [QueryKeys, unknown]>({
        queryKey: ['timelineAndDensity', params],
        queryFn: () => queryFn(params),
    });
};

export interface QueryParams {
    filter: {
        filters: IFilter[];
    };
}

export interface IData {
    endDate: number;
    startDate: number;
    score: number;
    percentile: number;
    numOfTasksPerMonth: number;
    numOfDelayDrivers: number;
}

export interface IHeatMapPortfolioProjectResponse {
    id: string;
    data: IData[];
    baselineData: IData[];
    label: string;
    versionHashCode: number;
    completionPercent: number;
    spiCriticality: number;
    spiMilestone: number;
    preferredSpiMethod: string | null;
}

export interface QueryResponse {
    heatMapPortfolioProjectResponse: IHeatMapPortfolioProjectResponse[];
    info: IToolTip;
}
